/**
 * @generated SignedSource<<239650e8235a0d352d43b61caa9f545a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoOverviewListItemWidget_Todo$data = {
  readonly id: string;
  readonly status: TodoStatus;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCircleWidgetOverview_Todo" | "TodoOverviewListItemExpireInfo_Todo" | "TodoOverviewListItemFooter_Todo">;
  readonly " $fragmentType": "TodoOverviewListItemWidget_Todo";
};
export type TodoOverviewListItemWidget_Todo$key = {
  readonly " $data"?: TodoOverviewListItemWidget_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoOverviewListItemWidget_Todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoOverviewListItemWidget_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoOverviewListItemExpireInfo_Todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoOverviewListItemFooter_Todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoCircleWidgetOverview_Todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "59f9e20ef9bd7a3c451f1fc7265833de";

export default node;
